import P from "../../../@babel/runtime/helpers/esm/toConsumableArray.mjs";
import M from "../../../@babel/runtime/helpers/esm/defineProperty.mjs";
import w from "../../../@babel/runtime/helpers/esm/regeneratorRuntime.mjs";
import O from "../../../@babel/runtime/helpers/esm/objectSpread2.mjs";
import F from "../../../@babel/runtime/helpers/esm/asyncToGenerator.mjs";
import S from "../../../@rc-component/async-validator/es/index.mjs";
import * as V from "react";
import { warningOnce as G } from "../../../rc-util/es/warning.mjs";
import { defaultValidateMessages as T } from "./messages.mjs";
import { merge as W } from "../../../rc-util/es/utils/set.mjs";
var D = S;
function Y(c, i) {
  return c.replace(/\\?\$\{\w+\}/g, function(l) {
    if (l.startsWith("\\"))
      return l.slice(1);
    var u = l.slice(2, -1);
    return i[u];
  });
}
var L = "CODE_LOGIC_ERROR";
function C(c, i, l, u, s) {
  return E.apply(this, arguments);
}
function E() {
  return E = F(/* @__PURE__ */ w().mark(function c(i, l, u, s, f) {
    var e, d, v, b, n, o, p, h, m;
    return w().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return e = O({}, u), delete e.ruleIndex, D.warning = function() {
            }, e.validator && (d = e.validator, e.validator = function() {
              try {
                return d.apply(void 0, arguments);
              } catch (a) {
                return console.error(a), Promise.reject(L);
              }
            }), v = null, e && e.type === "array" && e.defaultField && (v = e.defaultField, delete e.defaultField), b = new D(M({}, i, [e])), n = W(T, s.validateMessages), b.messages(n), o = [], r.prev = 10, r.next = 13, Promise.resolve(b.validate(M({}, i, l), O({}, s)));
          case 13:
            r.next = 18;
            break;
          case 15:
            r.prev = 15, r.t0 = r.catch(10), r.t0.errors && (o = r.t0.errors.map(function(a, t) {
              var y = a.message, R = y === L ? n.default : y;
              return /* @__PURE__ */ V.isValidElement(R) ? (
                // Wrap ReactNode with `key`
                /* @__PURE__ */ V.cloneElement(R, {
                  key: "error_".concat(t)
                })
              ) : R;
            }));
          case 18:
            if (!(!o.length && v)) {
              r.next = 23;
              break;
            }
            return r.next = 21, Promise.all(l.map(function(a, t) {
              return C("".concat(i, ".").concat(t), a, v, s, f);
            }));
          case 21:
            return p = r.sent, r.abrupt("return", p.reduce(function(a, t) {
              return [].concat(P(a), P(t));
            }, []));
          case 23:
            return h = O(O({}, u), {}, {
              name: i,
              enum: (u.enum || []).join(", ")
            }, f), m = o.map(function(a) {
              return typeof a == "string" ? Y(a, h) : a;
            }), r.abrupt("return", m);
          case 26:
          case "end":
            return r.stop();
        }
    }, c, null, [[10, 15]]);
  })), E.apply(this, arguments);
}
function x(c, i, l, u, s, f) {
  var e = c.join("."), d = l.map(function(n, o) {
    var p = n.validator, h = O(O({}, n), {}, {
      ruleIndex: o
    });
    return p && (h.validator = function(m, g, r) {
      var a = !1, t = function() {
        for (var A = arguments.length, $ = new Array(A), k = 0; k < A; k++)
          $[k] = arguments[k];
        Promise.resolve().then(function() {
          G(!a, "Your validator function has already return a promise. `callback` will be ignored."), a || r.apply(void 0, $);
        });
      }, y = p(m, g, t);
      a = y && typeof y.then == "function" && typeof y.catch == "function", G(a, "`callback` is deprecated. Please return a promise instead."), a && y.then(function() {
        r();
      }).catch(function(R) {
        r(R || " ");
      });
    }), h;
  }).sort(function(n, o) {
    var p = n.warningOnly, h = n.ruleIndex, m = o.warningOnly, g = o.ruleIndex;
    return !!p == !!m ? h - g : p ? 1 : -1;
  }), v;
  if (s === !0)
    v = new Promise(/* @__PURE__ */ function() {
      var n = F(/* @__PURE__ */ w().mark(function o(p, h) {
        var m, g, r;
        return w().wrap(function(t) {
          for (; ; )
            switch (t.prev = t.next) {
              case 0:
                m = 0;
              case 1:
                if (!(m < d.length)) {
                  t.next = 12;
                  break;
                }
                return g = d[m], t.next = 5, C(e, i, g, u, f);
              case 5:
                if (r = t.sent, !r.length) {
                  t.next = 9;
                  break;
                }
                return h([{
                  errors: r,
                  rule: g
                }]), t.abrupt("return");
              case 9:
                m += 1, t.next = 1;
                break;
              case 12:
                p([]);
              case 13:
              case "end":
                return t.stop();
            }
        }, o);
      }));
      return function(o, p) {
        return n.apply(this, arguments);
      };
    }());
  else {
    var b = d.map(function(n) {
      return C(e, i, n, u, f).then(function(o) {
        return {
          errors: o,
          rule: n
        };
      });
    });
    v = (s ? z(b) : q(b)).then(function(n) {
      return Promise.reject(n);
    });
  }
  return v.catch(function(n) {
    return n;
  }), v;
}
function q(c) {
  return I.apply(this, arguments);
}
function I() {
  return I = F(/* @__PURE__ */ w().mark(function c(i) {
    return w().wrap(function(u) {
      for (; ; )
        switch (u.prev = u.next) {
          case 0:
            return u.abrupt("return", Promise.all(i).then(function(s) {
              var f, e = (f = []).concat.apply(f, P(s));
              return e;
            }));
          case 1:
          case "end":
            return u.stop();
        }
    }, c);
  })), I.apply(this, arguments);
}
function z(c) {
  return j.apply(this, arguments);
}
function j() {
  return j = F(/* @__PURE__ */ w().mark(function c(i) {
    var l;
    return w().wrap(function(s) {
      for (; ; )
        switch (s.prev = s.next) {
          case 0:
            return l = 0, s.abrupt("return", new Promise(function(f) {
              i.forEach(function(e) {
                e.then(function(d) {
                  d.errors.length && f([d]), l += 1, l === i.length && f([]);
                });
              });
            }));
          case 2:
          case "end":
            return s.stop();
        }
    }, c);
  })), j.apply(this, arguments);
}
export {
  x as validateRules
};
//# sourceMappingURL=validateUtil.mjs.map
